<p>activate works!</p>
